<template>
  <div class="apply-form">
    <!-- <back title="证书申请" /> -->
    <div class="container">
      <div class="info">
        <div class="title">{{ title }}</div>
        <div class="info-a">
          <span class="sub-current" v-if="text && subjectName"> {{ text }}-{{ subjectName }} </span>
          <span class="sub-current" v-else>无课程科目</span>
          <span class="time-current">{{ startDate | format_Date }} {{ startDate | format_Date_a }}-{{ endDate |
              format_Date_a
          }}</span>
        </div>
        <div class="info-b" v-if="applyType === 1">
          <span>直播观看{{ liveTime | watch_record_format }}，</span>
          <span>点播观看{{ recordTime | watch_record_format }}</span>
        </div>
        <div class="info-b current">
          <span>预计{{ applyType === 1 ? userClassHour : maxClassHour }}学时</span>
        </div>
        <div class="info-c">
          <span class="i">个人信息为：{{ userSub }}</span>
          <div class="t">
            <i class="iconfont iconxinxi"></i>
            <span>科目信息不符</span>
          </div>
        </div>
      </div>
      <h3 class="title">
        说明
        <span>（字数限制：300字）</span>
      </h3>
      <div class="text-area">
        <textarea name="" v-model="tips" placeholder="请输入" required maxlength="300"></textarea>
      </div>
      <h3 class="title">上传证明<span>（请上传学校出具的证明并盖章）</span></h3>

      <div class="upload">
        <div class="upload-box">
          <i class="iconfont icon-add"></i>
          <input type="file" class="file-upload" @change="handleUploadFile" />
        </div>
        <ul class="img-list">
          <li class="img-item" v-for="(item, index) in imgList" :key="index">
            <i class="iconfont iconshan_chu" @click="handleRemove(index)"></i>
            <img :src="videoCdn + item" alt="" />
          </li>
        </ul>
      </div>
      <div class="confrim" @click="handleConfrim">确定</div>
    </div>

    <success-box :successShow="successShow" @CloseSuccess="handleCloseSuccess"></success-box>

    <reload-box :refreshShow="refreshShow" @refresh="handleRefresh"></reload-box>
  </div>
</template>

<script>
import SuccessBox from './components/successBox'
import ReloadBox from './components/reloadBox'
import { getUserStudyTimeByEvent, getUserClassHourForSignByEvent, insertClassHourApply } from '@/api/dd'
import { upload } from '@/api/index'
const emojiReg =
  // eslint-disable-next-line no-misleading-character-class
  /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\\A9|AE]\u3030|\uA9|\uAE|\u3030/gi
export default {
  name: 'apply-form',
  components: {
    // Back,
    SuccessBox,
    ReloadBox
  },
  data() {
    return {
      successShow: false,
      title: '',
      subjectName: '',
      text: '',
      maxClassHour: 0,
      userClassHour: '',
      startDate: '',
      endDate: '',
      liveTime: '',
      recordTime: '',
      userSub: '',
      tips: '',
      imgList: [],
      refreshShow: false,
      applyType: 1
    }
  },
  methods: {
    initData() {
      console.log('this.applyType', this.applyType)
      if (this.applyType === 2) {
        getUserClassHourForSignByEvent(this.$route.params.id).then((res) => {
          window.console.log('res', res)
          this.handleResult(res)
        })
      } else if (this.applyType === 1) {
        getUserStudyTimeByEvent(this.$route.params.id).then(res => {
          this.handleResult(res)
        })
      }
    },
    handleResult(res) {
      if (res.code === 0 && res.success) {
        const data = res.data
        this.title = data.event_name
        this.subjectName = data.subjectName
        this.text = data.text
        this.userClassHour = data.userClassHour
        this.maxClassHour = data.maxClassHour
        this.startDate = data.event_start_time
        this.endDate = data.event_end_time
        this.liveTime = data.live_study_time
        this.recordTime = data.record_study_time
        let str = ''
        this.infoSub = data.userSubjects.forEach(item => {
          str += `${item.stageName}-${item.subjectName}  `
        })
        this.userSub = str
      }
    },
    handleConfrim() {
      // this.successShow = true;
      if (!this.tips) {
        this.$Toast.fail('说明不能为空')
        return false
      } else if (emojiReg.test(this.tips)) {
        this.$Toast.fail('说明不能含有emoji表情')
        return false
      } else if (this.imgList.length <= 0) {
        this.$Toast.fail('至少上传一张证明')
        return false
      } else {
        console.log('Ok')
        insertClassHourApply({
          applyClassHour: this.userClassHour,
          applyExplain: this.tips,
          eventInfoId: this.$route.params.id,
          proveOne: this.imgList[0] ? this.imgList[0] : '',
          proveTwo: this.imgList[1] ? this.imgList[1] : '',
          proveThree: this.imgList[2] ? this.imgList[2] : ''
        }).then(res => {
          if (res.code === 0 && res.success) {
            if (res.data && res.data === -4) {
              this.refreshShow = true
            } else {
              this.successShow = true
              setTimeout(() => {
                this.successShow = false
                this.$router.replace('/home')
              }, 2000)
            }
          }
        })
      }
    },
    handleCloseSuccess() {
      this.successShow = false
    },
    handleUploadFile(e) {
      if (this.imgList.length >= 3) {
        this.$Toast.fail('最多上传3张')
        return false
      } else {
        const file = e.target.files[0]
        const form = new FormData()
        console.log('file', file)
        form.append('file', file)
        if (file.type === 'image/png' || file.type === 'image/jpeg') {
          upload(form).then(res => {
            console.log('res', res)
            if (res.code === 0 && res.success) {
              this.imgList = [...this.imgList, res.data.smallPath]
            }
          })
        } else {
          this.$Toast.fail('文件格式不对')
        }
      }
    },
    handleRemove(index) {
      this.imgList.splice(index, 1)
    },
    handleRefresh() {
      this.$router.back()
    }
  },
  created() {
    this.applyType = Number(this.$route.query.applyType)
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.apply-form {
  width: 100%;

  .container {
    width: 100%;
    padding: 12px 16px;
    box-sizing: border-box;

    .info {
      width: 100%;
      padding: 20px 16px;
      border-radius: 12px;
      box-shadow: 0 0 12px 0 rgba(23, 38, 71, 0.1);
      background-color: #fff;
      box-sizing: border-box;

      .title {
        font-size: 16px;
        font-weight: 700;
        line-height: 28px;
        color: #303133;
      }

      .info-a {
        display: flex;
        align-items: center;
        margin-top: 16px;
        font-size: 14px;

        span {
          color: #909399;
        }

        .time-current {
          margin-left: 16px;
        }
      }

      .info-b {
        margin-top: 20px;
        font-size: 15px;

        &.current {
          margin-top: 12px;
        }

        span {
          color: #606266;
        }
      }

      .info-c {
        margin-top: 16px;
        display: flex;

        .i {
          flex: 0 0 185px;
          font-size: 14px;
          color: #606266;
        }

        .t {
          margin-left: 12px;

          i {
            color: #fda423;
          }

          span {
            margin-left: 5px;
            color: #fda423;
          }
        }
      }
    }

    .title {
      margin-top: 28px;
      color: #000000;
      font-weight: 700;

      span {
        color: #909399;
        font-size: 12px;
        font-weight: 400;
        vertical-align: baseline;
      }
    }

    .text-area {
      margin-top: 20px;
      width: 100%;
      height: 140px;
      padding: 16px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 0 12px 0 rgba(23, 38, 71, 0.1);

      textarea {
        width: 100%;
        height: 100%;
        outline: none;
        resize: none;
        border: none;
        color: #c0c4cc;
        font-size: 15px;
        line-height: 24px;

        &::-webkit-input-placeholder {
          color: #c0c4cc;
        }
      }
    }

    .upload {
      margin-top: 20px;
      display: flex;

      .upload-box {
        flex: 0 0 100px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100px;
        border: 1px solid #e8e9ec;
        border-radius: 8px;

        i {
          font-size: 35px;
          color: #c0c4cc;
        }

        .file-upload {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          outline: none;
          opacity: 0;
        }
      }

      .img-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .img-item {
          position: relative;
          margin-left: 18px;
          margin-bottom: 18px;
          width: 100px;
          height: 100px;
          border-radius: 8px;

          img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            border-radius: 8px;
            z-index: -2;
          }

          i {
            position: absolute;
            right: -10px;
            top: -10px;
            z-index: 1;
            font-size: 20px;
          }
        }
      }
    }

    .confrim {
      margin-top: 24px;
      width: 100%;
      height: 47px;
      font-size: 16px;
      color: #fff;
      border-radius: 12px;
      text-align: center;
      line-height: 47px;
      background: linear-gradient(90deg, #4a86f6, #4465f3);
    }
  }
}
</style>
